export const canAddMoreMembers = (entitlementValue: number, currentCount: number | null) =>
  currentCount ? currentCount < entitlementValue : false

export const canAddMoreReportingForms = (entitlementValue: number, currentCount: number | null) =>
  currentCount ? currentCount < entitlementValue : false
